<div [hidden]="!Active" class="pane" style="height:100%;" [ngStyle]="{'max-height': (MaxHeight != 0) ? MaxHeight + 'px' : '90%', 'overflow':'auto'}">
    <ng-content></ng-content>
</div>